module.exports = __webpack_public_path__ + "assets/c0fd9aefb3e5e72fb4bc95deae5d70aa.mp4";